type MineSite = {
  code: string;
  name: string;
};

const MINE_SITES: MineSite[] = [
  { code: 'br2', name: 'Brockman 2' },
  { code: 'br4', name: 'Brockman 4' },
  { code: 'koo', name: 'Gudai-darri' },
  { code: 'hd1', name: 'Hope Downs 1' },
  { code: 'hd4', name: 'Hope Downs 4' },
  { code: 'mar', name: 'Marandoo' },
  { code: 'msa', name: 'Mesa A' },
  { code: 'msj', name: 'Mesa J' },
  { code: 'par', name: 'Paraburdoo' },
  { code: 'sge', name: 'Silvergrass' },
  { code: 'tpr', name: 'Tom Price' },
  { code: 'wan', name: 'West Angelas' },
  { code: 'wts', name: 'Western Turner Syncline' },
  { code: 'yan', name: 'Yandi' },
];

export { MINE_SITES, type MineSite };
